// Modal da newsletter (layouts/newstyle/_newsletter_modal).
// Gatilhos (data-trigger, definido pela página em NewStyleHelper#newsletter_modal_trigger):
// - exit: no computador, quando o mouse sai pela parte de cima da janela (indo para as abas ou a
//   barra de endereço), depois de pelo menos 5s na página. No celular, que não tem mouse, quando a
//   pessoa já rolou metade da página e volta rápido para cima (o gesto de quem está saindo).
// - engaged: rolou 60% da página ou ficou 45s nela.
// Para testar: ?newsletter=open na URL abre o modal na hora, mesmo com o cookie.
// Abre no máximo uma vez por página. Fechou (X, Esc, clique fora) → cookie cda_newsletter por
// 14 dias; assinou (ou o e-mail já estava na lista) → por 1 ano. O servidor já não renderiza o
// modal para quem está logado nem no carrinho/checkout/pagamento.

var COOKIE = 'cda_newsletter';
var CLOSED_DAYS = 14;
var SUBSCRIBED_DAYS = 365;
var EXIT_MIN_DWELL = 5000;
var EXIT_EDGE = 20; // px do topo: o último evento do mouse saindo rápido chega antes da borda
var MOBILE_EXIT_DEPTH = 0.5;
var MOBILE_EXIT_SPEED = 60; // px de subida entre dois eventos de rolagem
var ENGAGED_DEPTH = 0.6;
var ENGAGED_TIME = 45000;

var teardown = null;

function dismissed() {
  return document.cookie.indexOf(COOKIE + '=') !== -1;
}

function remember(value, days) {
  document.cookie = COOKIE + '=' + value + ';path=/;max-age=' + (days * 86400) + ';SameSite=Lax';
}

function scrollDepth() {
  var doc = document.documentElement;
  var max = doc.scrollHeight - window.innerHeight;
  return max > 0 ? window.scrollY / max : 1;
}

// outro modal na tela (Bootstrap, outro <dialog>): não empilha
function otherModalOpen(dialog) {
  return !!document.querySelector('.modal.show, body.modal-open') ||
    Array.prototype.some.call(document.querySelectorAll('dialog[open]'), function(d) { return d !== dialog; });
}

function setup(dialog, forced) {
  var form = dialog.querySelector('[data-cda-newsletter-form]');
  var errorBox = dialog.querySelector('.cda-nl__error');
  var submit = form.querySelector('.cda-nl__submit');
  var submitLabel = submit.querySelector('[data-label]');
  var subscribed = false;
  var shown = false;
  var listeners = [];

  function listen(target, type, handler, options) {
    target.addEventListener(type, handler, options);
    listeners.push(function() { target.removeEventListener(type, handler, options); });
  }

  function stopTriggers() {
    listeners.forEach(function(off) { off(); });
    listeners = [];
  }

  function open() {
    if (shown || (dismissed() && !forced) || otherModalOpen(dialog) || typeof dialog.showModal !== 'function') return;
    shown = true;
    stopTriggers();
    dialog.showModal();
    // o foco vai para o primeiro campo, não para o X
    var first = form.querySelector('input:not([type=hidden])');
    if (first) first.focus({ preventScroll: true });
  }

  function close() {
    if (dialog.open) dialog.close();
  }

  // X, "continuar navegando" e clique no fundo escuro (fora do cartão)
  dialog.addEventListener('click', function(event) {
    if (event.target === dialog || event.target.closest('[data-cda-newsletter-close]')) close();
  });
  dialog.addEventListener('close', function() {
    if (!subscribed) remember('closed', CLOSED_DAYS);
  });

  // positive: mensagem que não é erro (o e-mail já estava na lista), na cor da marca
  function showError(text, positive) {
    errorBox.textContent = text;
    errorBox.hidden = !text;
    errorBox.classList.toggle('is-positive', !!positive);
  }

  function showDone() {
    subscribed = true;
    remember('subscribed', SUBSCRIBED_DAYS);
    dialog.querySelector('[data-cda-newsletter-step="form"]').hidden = true;
    dialog.querySelector('[data-cda-newsletter-step="done"]').hidden = false;
    dialog.querySelector('[data-cda-newsletter-done-title]').focus();
  }

  form.addEventListener('submit', function(event) {
    event.preventDefault();
    var email = form.querySelector('input[type=email]');
    if (!email.value.trim()) return showError(dialog.getAttribute('data-error-blank'));
    if (email.validity.typeMismatch) return showError(dialog.getAttribute('data-error-invalid'));

    showError('');
    var label = submitLabel.textContent;
    submit.disabled = true;
    submitLabel.textContent = dialog.getAttribute('data-sending');

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (data.ok) return showDone();
        if (data.error === 'taken') {
          // já estava na lista: não precisa ver o convite de novo
          subscribed = true;
          remember('subscribed', SUBSCRIBED_DAYS);
        }
        showError(dialog.getAttribute('data-error-' + data.error) || dialog.getAttribute('data-error-generic'),
                  data.error === 'taken');
      })
      .catch(function() { showError(dialog.getAttribute('data-error-generic')); })
      .then(function() {
        submit.disabled = false;
        submitLabel.textContent = label;
      });
  });

  // gatilhos
  var trigger = dialog.getAttribute('data-trigger');
  var startedAt = Date.now();

  if (trigger === 'engaged') {
    var timer = setTimeout(open, ENGAGED_TIME);
    listeners.push(function() { clearTimeout(timer); });
    listen(window, 'scroll', function() {
      if (scrollDepth() >= ENGAGED_DEPTH) open();
    }, { passive: true });
  } else {
    listen(document.documentElement, 'mouseleave', function(event) {
      if (event.clientY <= EXIT_EDGE && Date.now() - startedAt >= EXIT_MIN_DWELL) open();
    });
  }

  if (trigger === 'exit' && window.matchMedia('(pointer: coarse)').matches) {
    var lastY = window.scrollY;
    var deepest = 0;
    listen(window, 'scroll', function() {
      var y = window.scrollY;
      deepest = Math.max(deepest, scrollDepth());
      if (deepest >= MOBILE_EXIT_DEPTH && lastY - y >= MOBILE_EXIT_SPEED) open();
      lastY = y;
    }, { passive: true });
  }

  if (forced) setTimeout(open, 300);

  return function() {
    stopTriggers();
    close();
  };
}

document.addEventListener('turbolinks:load', function() {
  if (teardown) teardown();
  teardown = null;

  var dialog = document.querySelector('[data-cda-newsletter]');
  if (!dialog) return;
  var forced = /[?&]newsletter=open\b/.test(window.location.search);
  if (dismissed() && !forced) return;
  teardown = setup(dialog, forced);
});

// sai da página pelo Turbolinks: para de ouvir e não guarda o modal aberto no cache
document.addEventListener('turbolinks:before-cache', function() {
  if (teardown) teardown();
  teardown = null;
});
